import { alertActions } from '.';
import { smoothieConstants } from '_constants';
import { smoothieService } from '_services';
import { history } from '_helpers';

export const smoothieActions = {
    getAll,
    getActive,
    delete: _delete,
};

function getActive() {
    return (dispatch) => {
        dispatch(request());

        smoothieService.getActive()
            .then(
                smoothies => dispatch(success(smoothies)),
                error => dispatch(failure(error.toString())),
            );
    };

    function request() {
        return { type: smoothieConstants.GETACTIVE_REQUEST };
    }
    function success(smoothies) {
        return { type: smoothieConstants.GETACTIVE_SUCCESS, smoothies };
    }
    function failure(error) {
        return { type: smoothieConstants.GETACTIVE_FAILURE, error };
    }
}

function getAll() {
    return (dispatch) => {
        dispatch(request());

        smoothieService.getAll()
            .then(
                allSmoothies => dispatch(success(allSmoothies)),
                error => dispatch(failure(error.toString())),
            );
    };

    function request() {
        return { type: smoothieConstants.GETALL_REQUEST };
    }
    function success(allSmoothies) {
        return { type: smoothieConstants.GETALL_SUCCESS, allSmoothies };
    }
    function failure(error) {
        return { type: smoothieConstants.GETALL_FAILURE, error };
    }
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
    return (dispatch) => {
        dispatch(request(id));

        smoothieService.delete(id)
            .then(
                smoothie => dispatch(success(id)),
                error => dispatch(failure(id, error.toString())),
            );
    };

    function request(id) {
        return { type: smoothieConstants.DELETE_REQUEST, id };
    }
    function success(id) {
        return { type: smoothieConstants.DELETE_SUCCESS, id };
    }
    function failure(id, error) {
        return { type: smoothieConstants.DELETE_FAILURE, id, error };
    }
}



// WEBPACK FOOTER //
// ./src/_actions/smoothie.actions.js